const resources = {
    title: 'Try Smart Skin Scan',
    subtitle: 'Get products recs in seconds with our AI-powered tool.',
    tryNow: 'Try Now'
};

export default function getResource(label) {
    return resources[label];
}
